export default __webpack_public_path__ + "static/media/logo.de3cf7e0.png";